import { LoanStatement } from "@/modules/loan/components";

export const LoanStatementPage = () => {

  return (
    <div className="full-width page-container">
      <LoanStatement/>
    </div>
  );
};
